import { createPortal } from 'react-dom';
import { Toaster } from 'react-hot-toast';

export default function ToastContainer() {
  const toaster = (
    <Toaster
      position="top-right"
      containerStyle={{
        // Full-screen sheets live at z-[100080]–[100220]; toasts must clear them.
        zIndex: 100500,
        // Push below the iOS safe area (notch / status bar) instead of under it.
        top: 'calc(env(safe-area-inset-top, 0px) + 16px)',
        right: 'calc(env(safe-area-inset-right, 0px) + 16px)',
      }}
      toastOptions={{
        duration: 5000,
        style: {
          background: '#fff',
          color: '#333',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          padding: '16px',
          borderRadius: '8px',
          fontSize: '14px',
          zIndex: 100500,
        },
        success: {
          iconTheme: {
            primary: '#10B981',
            secondary: '#fff',
          },
        },
        error: {
          iconTheme: {
            primary: '#EF4444',
            secondary: '#fff',
          },
        },
      }}
    />
  );

  // `#root` has `isolation: isolate` (see index.css), which traps anything
  // rendered inside it in its own stacking context. Modals that portal to
  // <body> (z 100200+) would then paint over the toaster regardless of its
  // z-index. Portal the toaster to <body> so the z-index comparison is fair.
  if (typeof document === 'undefined') return toaster;
  return createPortal(toaster, document.body);
}
